export default __webpack_public_path__ + "static/media/Shinjuku_Park_Girl.da15cb9c.jpg";